// extracted by mini-css-extract-plugin
export default {"main":"WhiteContainer_main__ga28F"};